import { FeatureAppLoader } from '@feature-hub/react';
import React from 'react';
import { PortalContext } from '../../../context/PortalContext';
import { Vehicle } from '@esportal/portal-service';
import type { FeatureAppConfiguration } from '@volkswagen-onehub/featureapp-service';

export const CitaPosventaLoader = ({
	vehicle,
	kvpsCode,
	motivo,
	onClose,
}: {
	vehicle: Vehicle;
	kvpsCode?: string | undefined;
	motivo?: string | undefined;
	onClose: () => void;
}) => {
	const { featureAppService } = React.useContext(PortalContext);
	const [showOneForm, setShowOneForm] = React.useState<boolean>(false);
	const featureAppRef = React.useRef<FeatureAppConfiguration | null>(null);
	const vehicleArray = React.useMemo(() => [vehicle], [vehicle]);

	React.useEffect(() => {
		if (!showOneForm) {
			setShowOneForm(true);
		}
	}, [showOneForm]);

	React.useEffect(() => {
		const featureApp = featureAppService.featureAppConfigurations['es-oneform-cita-posventa-embedded'];
		featureAppRef.current = featureApp;
	}, [showOneForm, featureAppService]);

	const renderOneForm = (vehicleArray: Vehicle[]) => {
		const featureAppConfig = featureAppRef.current;
		if (!featureAppConfig) {
			return null;
		}

		return (
		<FeatureAppLoader
			{...featureAppConfig}
			featureAppId={`${featureAppConfig.name}:oneform`}
			done={() => {
				setShowOneForm(false);
				onClose();
			}}
			beforeCreate={(env) => {
				const featureServices = env.featureServices as Record<string, any>;
				if (featureServices['fa-content-service']) {
					featureServices['fa-content-service'].content = {
						featureApp: 'es-portal',
						vehicle: vehicleArray,
						kvpsCode: kvpsCode,
						motivo: motivo,
					};
				}
				if (featureServices['api-key-provider']) {
					featureServices['api-key-provider'].apiKey = featureAppConfig.apiKey;
				}
			}}
		/>
		);
	};

	return <>{showOneForm && vehicle ? renderOneForm(vehicleArray) : null}</>;
};
